/**
 * Timing for pricing UI — keep animations subtle and within product guidelines (≈200–350ms).
 */
export const PRICING_PRICE_ANIMATION_MS = 300;

/** Brief success tint on the animated price when the numeric value changes. */
export const PRICING_PRICE_VALUE_FLASH_MS = 300;

/** Framer Motion `duration` in seconds (≈280ms). */
export const PRICING_SAVINGS_ENTER_DURATION_S = 0.28;

/** Next-tier hint fade-in (seconds). */
export const PRICING_NEXT_HINT_FADE_DURATION_S = 0.2;

/** RewardSummary entrance (seconds), ~220ms. */
export const PRICING_REWARD_SUMMARY_ENTER_S = 0.22;
